module.exports = __webpack_public_path__ + "img/29_8.f5303072.png";